/**
 * Points Rank Rules V2 — 等级权益对比表格（可复用于多页面）
 * - 默认始终展示规则表格；无当前等级时不高亮
 * - 监听 prr2:rank-updated（来自 points-rank-v2）高亮当前等级列并滚动定位
 * - 对外 API：window.PRR2Rules.setCurrentTier(level)
 */
(function () {
  var RANK_UPDATED_EVENT = 'prr2:rank-updated';

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function toNumber(value) {
    var num = Number(value);
    return Number.isFinite(num) ? num : 0;
  }

  function padGoalCells(col, max) {
    col.querySelectorAll('.prr2-cell--goal[data-prr2-pad]').forEach(function (el) {
      el.remove();
    });
    var goals = col.querySelectorAll('.prr2-cell--goal:not([data-prr2-pad])');
    var insertBefore = col.querySelector('.prr2-cell--reward:not([data-prr2-pad])');
    for (var i = goals.length; i < max; i += 1) {
      var empty = document.createElement('div');
      empty.className = 'prr2-cell prr2-cell--goal';
      empty.setAttribute('data-prr2-pad', 'true');
      empty.setAttribute('aria-hidden', 'true');
      if (insertBefore) {
        col.insertBefore(empty, insertBefore);
      } else {
        col.appendChild(empty);
      }
    }
  }

  function padRewardCells(col, max) {
    col.querySelectorAll('.prr2-cell--reward[data-prr2-pad]').forEach(function (el) {
      el.remove();
    });
    var rewards = col.querySelectorAll('.prr2-cell--reward:not([data-prr2-pad])');
    for (var i = rewards.length; i < max; i += 1) {
      var empty = document.createElement('div');
      empty.className = 'prr2-cell prr2-cell--reward';
      empty.setAttribute('data-prr2-pad', 'true');
      empty.setAttribute('aria-hidden', 'true');
      col.appendChild(empty);
    }
  }

  function getRowCells(cols, selector, index) {
    var cells = [];
    cols.forEach(function (col) {
      var cell = col.querySelectorAll(selector)[index];
      if (cell) cells.push(cell);
    });
    return cells;
  }

  function resetCellHeights(cells) {
    cells.forEach(function (cell) {
      cell.style.height = '';
      cell.style.minHeight = '';
    });
  }

  function measureRowHeights(cols, selector, rowCount) {
    var heights = [];
    var i;
    for (i = 0; i < rowCount; i += 1) {
      var rowCells = getRowCells(cols, selector, i);
      var maxH = 0;
      rowCells.forEach(function (cell) {
        maxH = Math.max(maxH, cell.offsetHeight);
      });
      heights.push(maxH);
    }
    return heights;
  }

  function applyRowHeights(cols, selector, heights) {
    heights.forEach(function (height, index) {
      var px = height + 'px';
      getRowCells(cols, selector, index).forEach(function (cell) {
        cell.style.height = px;
        cell.style.minHeight = px;
      });
    });
  }

  function sumHeights(heights) {
    var total = 0;
    heights.forEach(function (height) {
      total += height;
    });
    return total;
  }

  onReady(function () {
    var root = document.querySelector('.points-rank-rules-v2');
    if (!root) return;

    var elScroll = root.querySelector('.js-prr2-table-scroll');
    var elFade = root.querySelector('.js-prr2-table-fade');
    var btnPrev = root.querySelector('.js-prr2-scroll-prev');
    var btnNext = root.querySelector('.js-prr2-scroll-next');
    var syncTimer = null;
    var currentTierLevel = null;

    function markCurrentTier(level) {
      root.querySelectorAll('.js-prr2-tier-col').forEach(function (col) {
        var colLevel = toNumber(col.getAttribute('data-tier-level'));
        col.classList.toggle('is-current', colLevel === level);
      });
    }

    function scrollToCurrentTier(level) {
      if (!elScroll || !level) return;

      var tierCols = elScroll.querySelector('.js-prr2-tier-cols');
      if (!tierCols) return;

      var targetCol = tierCols.querySelector('.js-prr2-tier-col[data-tier-level="' + level + '"]');
      if (!targetCol) return;

      var colWidth = targetCol.offsetWidth;
      var colLeft = targetCol.offsetLeft;
      var viewport = elScroll.clientWidth;
      var maxScroll = Math.max(0, elScroll.scrollWidth - viewport);
      var scrollLeft = colLeft - (viewport - colWidth) / 2;

      elScroll.scrollLeft = Math.max(0, Math.min(scrollLeft, maxScroll));
      syncScrollButtons();
    }

    function clearCurrentTierHighlight() {
      currentTierLevel = null;
      root.querySelectorAll('.js-prr2-tier-col').forEach(function (col) {
        col.classList.remove('is-current');
      });
    }

    function setCurrentTier(level) {
      var numericLevel = toNumber(level);
      if (!numericLevel) return;
      currentTierLevel = numericLevel;
      markCurrentTier(numericLevel);
      scrollToCurrentTier(numericLevel);
    }

    function syncTableRowHeights() {
      var labelGoal = root.querySelector('.js-prr2-goal-label');
      var labelRewards = root.querySelector('.js-prr2-rewards-label');
      var cols = root.querySelectorAll('.js-prr2-tier-col');
      var maxGoals = 0;
      var maxRewards = 0;

      cols.forEach(function (col) {
        var goalCount = col.querySelectorAll('.prr2-cell--goal:not([data-prr2-pad])').length;
        var rewardCount = col.querySelectorAll('.prr2-cell--reward:not([data-prr2-pad])').length;
        if (goalCount > maxGoals) maxGoals = goalCount;
        if (rewardCount > maxRewards) maxRewards = rewardCount;
      });

      cols.forEach(function (col) {
        padGoalCells(col, maxGoals);
        padRewardCells(col, maxRewards);
      });

      var tierCells = root.querySelectorAll('.js-prr2-tier-col .prr2-cell--goal, .js-prr2-tier-col .prr2-cell--reward');
      resetCellHeights(Array.prototype.slice.call(tierCells));
      resetCellHeights([labelGoal, labelRewards].filter(Boolean));

      void root.offsetHeight;

      var goalHeights = measureRowHeights(cols, '.prr2-cell--goal', maxGoals);
      var rewardHeights = measureRowHeights(cols, '.prr2-cell--reward', maxRewards);

      applyRowHeights(cols, '.prr2-cell--goal', goalHeights);
      applyRowHeights(cols, '.prr2-cell--reward', rewardHeights);

      if (labelGoal && goalHeights.length) {
        var goalTotal = sumHeights(goalHeights) + 'px';
        labelGoal.style.height = goalTotal;
        labelGoal.style.minHeight = goalTotal;
      }
      if (labelRewards && rewardHeights.length) {
        var rewardTotal = sumHeights(rewardHeights) + 'px';
        labelRewards.style.height = rewardTotal;
        labelRewards.style.minHeight = rewardTotal;
      }

      if (currentTierLevel) {
        scrollToCurrentTier(currentTierLevel);
      }
    }

    function scheduleSyncTableRowHeights() {
      if (syncTimer) window.clearTimeout(syncTimer);
      syncTimer = window.setTimeout(syncTableRowHeights, 50);
    }

    function syncScrollButtons() {
      if (!elScroll || !btnPrev || !btnNext) return;
      var maxScroll = elScroll.scrollWidth - elScroll.clientWidth;
      var atStart = elScroll.scrollLeft <= 1;
      var atEnd = elScroll.scrollLeft >= maxScroll - 1;

      btnPrev.disabled = atStart || maxScroll <= 0;
      btnNext.disabled = atEnd || maxScroll <= 0;
      btnPrev.classList.toggle('is-active', !atStart);
      btnNext.classList.toggle('is-active', !atEnd);
      if (elFade) {
        elFade.style.opacity = atEnd || maxScroll <= 0 ? '0' : '1';
      }
    }

    function scrollTable(direction) {
      if (!elScroll) return;
      var colWidth = parseInt(getComputedStyle(root).getPropertyValue('--prr2-tier-col-width'), 10) || 210;
      elScroll.scrollBy({ left: direction * colWidth, behavior: 'smooth' });
    }

    function bindScrollControls() {
      if (btnPrev) {
        btnPrev.addEventListener('click', function () {
          scrollTable(-1);
        });
      }
      if (btnNext) {
        btnNext.addEventListener('click', function () {
          scrollTable(1);
        });
      }
      if (elScroll) {
        elScroll.addEventListener('scroll', syncScrollButtons, { passive: true });
        window.addEventListener('resize', syncScrollButtons);
      }
    }

    function onRankUpdated(ev) {
      var data = ev && ev.detail;
      if (!data) return;

      if (!data.enableEngagementLevel || !data.currentLevel) {
        clearCurrentTierHighlight();
        return;
      }

      setCurrentTier(data.currentLevel);
    }

    window.PRR2Rules = window.PRR2Rules || {};
    window.PRR2Rules.setCurrentTier = setCurrentTier;
    window.PRR2Rules.clearCurrentTier = clearCurrentTierHighlight;

    bindScrollControls();
    syncTableRowHeights();
    syncScrollButtons();
    document.addEventListener(RANK_UPDATED_EVENT, onRankUpdated);
    window.addEventListener('resize', scheduleSyncTableRowHeights);
    window.addEventListener('load', syncTableRowHeights);

    var initialTier = root.getAttribute('data-initial-tier');
    if (window.__PRR2_LAST_RANK) {
      onRankUpdated({ detail: window.__PRR2_LAST_RANK });
    } else if (initialTier) {
      setCurrentTier(initialTier);
    }

    if (typeof ResizeObserver !== 'undefined') {
      var table = root.querySelector('.js-prr2-table');
      if (table) {
        var resizeObserver = new ResizeObserver(scheduleSyncTableRowHeights);
        resizeObserver.observe(table);
      }
    }
  });
})();
